import { useEffect } from "react";

export default function (subscribeEvent: () => (() => void)) {
    useEffect(() => {
        const unsubscribe = subscribeEvent();
        
        return () => unsubscribe();
    }, []);
}